export default "__VITE_ASSET__B0tY7sMy__"